export default "/images/c242d08df6646015895b01735de51e66.avif";